module.exports = __webpack_public_path__ + "static/img/bLogo@2x.ff238ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bLogo@2x.png
// module id = FP94
// module chunks = 1